import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { Button } from "../../atoms/Button";
import { Input } from "../../atoms/Input";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  handleSubmit: (password: string, onError: () => void) => void;
};

export const ResetPasswordForm: React.FC<Props> = ({ handleSubmit }) => {
  const [hasPasswordError, setHasPasswordError] = useState<boolean>(false);

  const schema = useMemo(() => {
    return z
      .object({
        password: z.string().min(1),
        passwordConfirmation: z.string().min(1),
      })
      .refine((data) => data.password === data.passwordConfirmation);
  }, []);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    unknown,
    FieldValues
  > | null>(null);

  return (
    <FormTemplate
      schema={schema}
      setMethods={setMethods}
      defaultValues={{ password: "", passwordConfirmation: "" }}
      onSubmit={({ password }) =>
        handleSubmit(password, () => setHasPasswordError(true))
      }
    >
      <StyledTextContainer>
        新しいパスワードを入力してください。
      </StyledTextContainer>

      <StyledInputContainer>
        <Input
          label="新しいパスワード"
          name="password"
          type="password"
          autoFocus
          required
          helperText="大文字・小文字、数字をそれぞれ1文字以上含む10〜16文字以内でご入力ください"
          hasError={hasPasswordError}
        />
        <Input
          label="新しいパスワード（確認用）"
          name="passwordConfirmation"
          type="password"
          required
          hasError={hasPasswordError}
        />
      </StyledInputContainer>

      <StyledFooter>
        <Button variant="filled" text="設定" type="submit" fullWidth />
      </StyledFooter>
    </FormTemplate>
  );
};

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 24px;
`;

const StyledInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const StyledFooter = styled.div`
  margin-top: 32px;
`;
